interface Step {
  image: string
  title: string
  description: string
}

export const contentModalStepsFGTS = {
  steps: [
    {
      image: '/passofgts1.png',
      title: 'Passo 1',
      description:
        'Faça login com seu CPF e senha cadastrada e em seguida clique no menu "Mais"',
    },
    {
      image: '/passofgts2.png',
      title: 'Passo 2',
      description:
        'Dentre as opções disponíveis clique na opção "Autorização de consulta ás informações do FGTS"',
    },
    {
      image: '/passofgts3.png',
      title: 'Passo 3',
      description: 'Em seguida clique em "Empréstimo saque aniversário"',
    },
    {
      image: '/passofgts4.png',
      title: 'Passo 4',
      description: 'Clique em "Adicionar instituição +"',
    },
    {
      image: '/passofgts5.png',
      title: 'Passo 5',
      description:
        'No campo de busca, digite o banco "Q.I SOCIEDADE DE CRÉDITO" e selecione essa opção',
    },
    {
      image: '/passofgts6.png',
      title: 'Passo 6',
      description:
        'Clique em "continuar" e conclua o compartilhamento das informações do seu FGTS',
    },
    {
      image: '/passofgts7.png',
      title: 'Passo 7',
      description:
        'Agora repita o processo acima para os bancos "J17" e "SINGULARE CORRETORA DE TITULOS MOBILIARIOS S.A."',
    },
  ] as Step[],
}
